"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _EmailSettingsFormComponent = _interopRequireDefault(require("./EmailSettingsFormComponent"));
var _APStepsComponent = _interopRequireDefault(require("../../../../common/APStepsComponent"));
var _APLabelWithText = _interopRequireDefault(require("../../../../common/APLabelWithText"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _Modal = _interopRequireDefault(require("../../../../common/Modal/Modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('theme-settings');
var EmailSettingsComponent = function EmailSettingsComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  var orderEmailsActive = props.orderEmailsActive,
    loginEmailsActive = props.loginEmailsActive;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openModal = _useState2[0],
    setIsOpen = _useState2[1];
  var toggleModal = function toggleModal() {
    return setIsOpen(!openModal);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('main')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Order Emails"),
    text: orderEmailsActive === 'true' ? 'Enabled' : 'Disabled',
    customClass: themeClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Login Emails"),
    text: loginEmailsActive === 'True' ? 'Disabled' : 'Enabled',
    customClass: themeClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('button-container')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: themeClasses(),
    onClick: toggleModal
  }, t("Edit"))), openModal && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: openModal,
    title: t("Edit Email Settings"),
    onCancel: toggleModal,
    close: toggleModal,
    customClass: themeClasses('ap-modal')
  }, /*#__PURE__*/_react["default"].createElement(_APStepsComponent["default"], {
    childComponents: [_EmailSettingsFormComponent["default"]],
    toggleModal: toggleModal
  }))));
};
EmailSettingsComponent.propTypes = {
  formValues: _propTypes["default"].object.isRequired
};
var mapStateToProps = function mapStateToProps(state) {
  var config = state.user.userConfig.find(function (i) {
    return i.Key === 'SendOrderEmails';
  });
  var loginConfig = state.user.userConfig.find(function (i) {
    return i.Key === 'LoginEmailOptOut';
  });
  var orderEmailsActive = false;
  var loginEmailsActive = false;
  if (config) {
    orderEmailsActive = config.Value;
  }
  if (loginConfig) loginEmailsActive = loginConfig.Value;
  return {
    orderEmailsActive: orderEmailsActive,
    loginEmailsActive: loginEmailsActive
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(EmailSettingsComponent);